import { useContext, useEffect, useState } from "react";
import Table from "../../../components/Table/Table";
import classes from '../../../styles/AllDevices.module.css';
import { LoaderContext } from "../../../context/LoaderContext";
import { START_LOADER, STOP_LOADER } from "../../../constants";
import { EventsService } from "../../../services/EventsService";
import moment from "moment";
import { momentTimeFormater } from "../../../utils/dateHelper";
import DateRangePicker from '../../../components/Inputs/DateRangePicker/DateRangePicker';
import { DropdownComponent } from "../../../components/Inputs/Input";
import Typography from "../../../components/Typography/Typography";
import CustomTooltip from "../../../components/CustomToolTip/CustomTooltip";
import { UilFileLandscapeAlt, UilInfoCircle, UilLightbulbAlt } from '@iconscout/react-unicons';
import ModalComponent from "../../../components/ModalComponent/ModalComponent";
import DataLogModal from "./DataLogModal";
import CommandLogsModal from "./CommandLogsModal";

import myClasses from '../../SmartCharging/SmartCharging.module.css';
import EventsLogModal from "./EventsLogModal";

const LIMIT = 15;
const today = new Date();
const yesterday = new Date(today);
yesterday.setDate(yesterday.getDate() - 1);

const defaultValue = {
    label: 'All',
    value: 'All',
};

const HistoryEvents = ({ instances, licenseTypeId, updateQueryParams, queryParamsData, }) => {
    const { dispatch: loaderDispatch } = useContext(LoaderContext);
    const startLoader = (payload) => loaderDispatch({ type: START_LOADER, payload });
    const stopLoader = (payload) => loaderDispatch({ type: STOP_LOADER, payload });
    const [events, setEvents] = useState([]);
    const [skip, setSkip] = useState(0);
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [dateRange, setDateRange] = useState({
        startDate: queryParamsData.dateRange ? new Date(queryParamsData.dateRange.startDate) : yesterday,
        endDate: queryParamsData.dateRange ? new Date(queryParamsData.dateRange.endDate) : today,
    });
    const [groups, setGroups] = useState([defaultValue]);
    const [selectedGroup, setSelectedGroup] = useState(queryParamsData.group ? queryParamsData.group : defaultValue);
    const [eventsLogModal, setEventsLogModal] = useState({ status: false, id: '' });
    const [commandLogModal, setCommandLogModal] = useState({ status: false, id: '' });
    const [dataLogModal, setDataLogModal] = useState({ status: false, data: '' });

    useEffect(() => {
        const groupOptions = instances.map((item) => {
            return {
                label: item.name,
                value: item._id
            }
        })
        setGroups([defaultValue, ...groupOptions]);
    }, [instances]);

    useEffect(() => {
        getEvents();
    }, []);

    const getEvents = () => {
        EventsService.GetEvents(
            selectedGroup.value,
            {
                licenseTypeId,
                startDate: momentTimeFormater(moment(dateRange.startDate).format('YYYY-MM-DD')).startOf('day').toDate(),
                endDate: momentTimeFormater(moment(dateRange.endDate).format('YYYY-MM-DD')).endOf('day').toDate(),
                skip,
                limit: LIMIT
            },
            () => startLoader('getEvents'),
            handleGetEventsSuccess,
            handleError,
            () => stopLoader('getEvents')
        );
    };

    const handleError = (err) => {
        console.log(err);
    };

    const handleGetEventsSuccess = ({ data }) => {

        const processedData = data?.data?.events?.map((item, index) => {
            return {
                's.no': index + 1,
                instanceName: item.instanceName,
                edgeId: item.edgeId,
                status: item.status,
                startSOC: item.startSOC || '--',
                endSOC: item.endSOC || '--',
                startTime: item.startTime ? momentTimeFormater(item.startTime).format('YYYY-MM-DD HH:mm:ss') : '--',
                endTime: item.endTime ? momentTimeFormater(item.endTime).format('YYYY-MM-DD HH:mm:ss') : '--',
                action: (
                    <div className={myClasses.ActionIcons}>
                        <div onClick={() => {
                            setEventsLogModal({
                                status: true,
                                id: item._id,
                            });
                        }}>
                            <CustomTooltip content={'Event Logs'}>
                                <UilFileLandscapeAlt size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                            </CustomTooltip>
                        </div>
                        <div onClick={() => {
                            setCommandLogModal({
                                status: true,
                                id: item._id,
                            });
                        }}>
                            <CustomTooltip content={'Command Logs'}>
                                <UilLightbulbAlt size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                            </CustomTooltip>
                        </div>
                        <div onClick={() => setDataLogModal({ status: true, data: item })}>
                            <CustomTooltip content={'Data Log'}>
                                <UilInfoCircle size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                            </CustomTooltip>
                        </div>
                    </div>
                )
            };
        });
        setEvents(processedData);
        setTotalCount(data?.data?.totalCount || 0)
    };

    const handlePageChange = (pageno) => {
        setSkip(LIMIT * pageno);
        setPage(pageno);
    };

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <div className={myClasses.FilterContainer}>
                <div className={myClasses.HeadingContainer}>
                </div>

                <div className={myClasses.DatePickers}>
                    <div className={classes.FieldControl2}>
                        <label>Instance</label>
                        <DropdownComponent name="groupId" options={groups} defaultValue={selectedGroup} onChange={(e) => {
                            setSelectedGroup(e);
                            updateQueryParams('group', JSON.stringify(e))
                        }} />
                    </div>

                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div className={classes.DateLabels}>Start Date</div>
                            <div className={classes.DateLabels} style={{ marginRight: '2.604vw' }}>
                                End Date
                            </div>
                        </div>
                        <DateRangePicker
                            startDate={dateRange.startDate}
                            endDate={dateRange.endDate}
                            onChange={(date) => {
                                const data = { startDate: new Date(date.startDate), endDate: new Date(date.endDate) };
                                setDateRange(data);
                                updateQueryParams('dateRange', JSON.stringify(data));
                            }}
                        />
                    </div>
                    <div
                        className={classes.SubmitButton}
                        onClick={() => {
                            getEvents();
                            setPage(0);
                        }}
                    >
                        <button className="btn-primary" style={{ marginTop: '1.2vw' }}>
                            Submit
                        </button>
                    </div>
                </div>
            </div>

            <div className={classes.Alert}>
                <div className={myClasses.wholeFilterWrapper}>
                    <div className={myClasses.HeadingContainer}>
                        <Typography content={`History`} />
                        <div className={classes.TableCount}>
                            Total Count :
                            <span>
                                <Typography size="14" content={events.length} />
                            </span>
                        </div>
                    </div>
                </div>
                <Table
                    head={[
                        'Instance',
                        'Edge ID',
                        'Status',
                        'Start SOC',
                        'End SOC',
                        'Start Time (CET)',
                        'End Time (CET)',
                        'Actions'
                    ]}
                    keys={[
                        'instanceName',
                        'edgeId',
                        'status',
                        'startSOC',
                        'endSOC',
                        'startTime',
                        'endTime',
                        'action'
                    ]}
                    data={events}
                    page={page}
                    Pagination={true}
                    limit={LIMIT}
                    handlePageChange={handlePageChange}
                    totalCount={totalCount}
                />
            </div>
            <ModalComponent isOpen={eventsLogModal.status} setOpen={() => setEventsLogModal({
                status: false,
                id: '',
            })}>
                <EventsLogModal setOpen={() => setEventsLogModal({ status: false, id: '' })} id={eventsLogModal.id} />
            </ModalComponent>
            <ModalComponent isOpen={commandLogModal.status} setOpen={() => setCommandLogModal({
                status: false,
                id: '',
            })}>
                <CommandLogsModal setOpen={() => setCommandLogModal({ status: false, id: '' })} id={commandLogModal.id} />
            </ModalComponent>
            <ModalComponent isOpen={dataLogModal.status} setOpen={() => setDataLogModal({
                status: false,
                data: '',
            })}>
                <DataLogModal setOpen={() => setDataLogModal({ status: false, data: '' })} data={dataLogModal.data} />
            </ModalComponent>
        </div>
    )
}

export default HistoryEvents;
